<template>
  <div class="menuexpansion">
    <div class="menuexpansion__icon" @click.stop="toggledDropdown(lists)">
      <i class="adx-ic_more" :class="{active: isOpen, white : isWhite}"></i>
    </div>
    <div class="menuexpansion__level1" v-if="isOpen" :class="{right : isRight}">
      <div class="menuexpansion__level1__action mobile">
        <i class="icon-close" @click.stop="closeDropdown"></i>
      </div>
      <ul :class="['menuexpansion__level1__wrapper', {left:isLevel1Left}, {bottom:isLevel1Bottom}]">
        <li v-for="list in lists" :key="list.id" @click.stop="!isMobile ? select(list) : hover(list, list.id, $event)" class="menuexpansion__level1__item" @mouseover="isMobile ? '' : hover(list, list.id, $event)" @mouseout="isMobile ? '' : ''">
          <span class="subhead">{{ list.name }}</span>
          <i v-if="list.items" class="icon-chevronright"></i>
          <!-- <level-2 v-if="expansion.includes(list.id)" :items="list.items" /> -->
          <div class="menuexpansion__level2">
            <ul @mouseout.stop v-if="expansion.includes(list.id)" :class="['menuexpansion__level2__wrapper', {left:isLevel2Left}, {bottom:isLevel2Bottom}]">
              <li class="subhead" @click="selectDeepLevel(list, index)" v-for="(item, index) in list.items" :key="index">
                <label-status :progress="item"/>
                <!-- {{item.name}} -->
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import StatusLevel2 from '@/components/MenuExpansionStatus/Level2Status'
import LabelStatus from '@/components/StatusLabel'
import vuescroll from 'vue-scroll'
 
Vue.use(vuescroll)

export default {
  name: 'adx-menu-expansion-status',
  props: {
    lists: {
      type: Array,
      required: true,
    },
    itemID: {
      required: false
    },
    isWhite: {
      required: false
    },
    isRight: {
      required: false
    }
  },
  components: {
    'level-2Status': StatusLevel2,
     LabelStatus,
  },
  mounted() {
    this.$nextTick(function() {
      if(!this.isMobile) {
        Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
      }
      document.body.addEventListener('keyup', e => {
        if (e.keyCode === 27) {
          this.closeDropdown()
        }
      })
      Vue.$broker.$on("on-scroll", this.closeAllDropdown.bind(this))
    })
  },
  data() {
    return {
      isOpen: false,
      isExpand: false,
      isMobile: window.innerWidth > 769 ? false : true,
      expansion: [],
      expansionLevel1CSSClass: '',
      expansionLevel2CSSClass: '',
      isLevel1Left: false,
      isLevel2Left: false,
      isLevel1Bottom: false,
      isLevel2Bottom: false
    }
  },
  methods: {
    closeAllDropdown() {
      this.closeDropdown()
      this.remove()
    },
    toggledDropdown(lists) {
      this.closeAllDropdown()
      Vue.$broker.$emit("app-click", this)
      this.isOpen = true
      if(this.isMobile) {
        document.body.style.overflow = "hidden"
        document.documentElement.style.overflow = "hidden"
        document.body.style.position = "relative" 
        document.documentElement.style.overflow = "relative"
        document.body.style.height = "100%" 
        document.documentElement.style.height = "100%"
      } else if (
        (window.innerHeight - event.clientY < 258 && lists.length > 5) ||
        (window.innerHeight - event.clientY < 219 && lists.length == 5) ||
        (window.innerHeight - event.clientY < 180 && lists.length == 4) ||
        (window.innerHeight - event.clientY < 141 && lists.length == 3) ||
        (window.innerHeight - event.clientY < 102 && lists.length == 2) ||
        (window.innerHeight - event.clientY < 63 && lists.length == 1)
      ) {
        this.isLevel1Bottom = true
        if (event.clientX <= 405){
          this.isLevel1Left = true
        } else {
          this.isLevel1Left = false
        }
      } else {
        this.isLevel1Bottom = false
        if (event.clientX <= 405){
          this.isLevel1Left = true
        } else {
          this.isLevel1Left = false
        }
      }
    },
    closeDropdown(sender) {
      this.isExpand = false
      if (sender === this) {
        return
      }
      this.isOpen = false
      if(this.isMobile) {
        document.body.style.overflow = '' 
        document.documentElement.style.overflow = ''
        document.body.style.position = '' 
        document.documentElement.style.overflow = ''
        document.body.style.height = '' 
        document.documentElement.style.height = ''
      }
    },
    select(list) {
      if(!list.items) {
        if (this.itemID) {
          list['item_id'] = this.itemID
        }
        this.$emit('selected', list)
        this.closeDropdown()
      }
    },
    selectDeepLevel(list, index) {
      let listReturn = {
        'value': list.value,
        'items': list.items[index]
      }
      if (this.itemID) {
        listReturn['item_id'] = this.itemID
      }
      this.$emit('selected', listReturn)
      this.closeDropdown()
    },
    hover(list, id, event) {
      let left = this.$route.name == 'saved' ? this.$parent.$el.offsetLeft : event.clientX

      if (this.isMobile) {
        if (this.expansion.includes(id)) {
          this.remove()
        } else {
          this.remove()
          if (list.items) {
            this.expansion.push(id)
          } else {
            this.select(list)
          }
        }
      } else {
        this.remove()
        if (list.items && this.isExpand == false) {
          this.expansion.push(id)
          if (
            (window.innerHeight - event.clientY < 258 && list.items.length > 5) ||
            (window.innerHeight - event.clientY < 219 && list.items.length == 5) ||
            (window.innerHeight - event.clientY < 180 && list.items.length == 4) ||
            (window.innerHeight - event.clientY < 141 && list.items.length == 3) ||
            (window.innerHeight - event.clientY < 102 && list.items.length == 2) ||
            (window.innerHeight - event.clientY < 63 && list.items.length == 1)
            
          ) {
            this.isLevel2Bottom = true

            if (left <= 505){
              this.isLevel2Left = true
            } else {
              this.isLevel2Left = false
            }
          } else {
            this.isLevel2Bottom = false
            if (left <= 405){
              this.isLevel2Left = true
            } else {
              this.isLevel2Left = false
            }
          }
          this.isExpand = true
        }
      }
    },
    remove() {
      this.expansion = []
      this.isExpand = false
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>